<label *ngIf="label"
  [attr.for]="id"
  soho-label
  [required]="isRequired"
  lm-label
  [layoutField]="field"
  [personalize]="personalize"
  lm-text-style
  [textStyle]="label?.textStyle">
  {{triggerValue | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
</label>
<div class="field">
  <div
    lm-field-options
    [hasContextMenu]="insertContextMenu && !displayAsText"
    [ajaxCallbackFunction]="onBeforeContextMenuOpen"
    [contextMenuEventFunction]="contextMenuClicked"
    [buttonId]="fieldOptionsId"
    [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
    [isInAccessibilityMode]="isInAccessibilityMode"
    [displayFieldOptions]="displayFieldOptions"
    [fieldAutomationId]="fieldAutomationId"
    soho-tooltip
    [popover]="true"
    [title]="popoverTitle"
    [placement]="'right'"
    [trigger]="'click'"
    (contextmenu)="onContextMenu($event)"
    (focusin)="onFieldFocus($event)"
    (focusout)="onFieldBlur($event)">
    <div>
      <ng-container *ngIf="(!isEmpty || displayAsText); else showInput">
        <!-- modelField.value cannot be on it's own line, as this introduces extra spaces around the text strings -->
        <p *ngIf="displayAsText"
          [attr.id]="id"
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          class="lm-text-data hide-white-space">{{modelField.value}}</p>
        <a
          *ngIf="!displayAsText"
          [attr.tabindex]="0"
          [attr.aria-label]="'OpenAttachment' | translate"
          [attr.id]="id"
          [attr.target]="modelField.mimeType === 'application/pdf' ? '_blank' : null"
          [attr.download]="modelField.mimeType === 'application/pdf' ? null : modelField.value"
          class="hyperlink"
          href="{{url}}">{{modelField.value}}</a>
        <button *ngIf="!displayAsText && !isReadOnly"
          soho-button="icon"
          icon="delete"
          soho-tooltip
          cy-data="delete-attachment"
          [title]="deleteAttachmentTitle"
          (click)="removeAttachment()">{{deleteAttachmentTitle}}</button>
      </ng-container>
    </div>
    <ng-template #showInput>
      <input
        [ngClass]="fieldClassesString"
        accept="true"
        [id]="bindId"
        [name]="bindId"
        [attr.value]="modelField.value"
        [attr.original]="originalValue"
        [attr.id]="id"
        [attr.bindId]="bindId"
        [attr.readonly]="isReadOnly ? true : null"
        soho-fileupload
        soho-alert
        soho-input-validate
        (error)="onError($event)"
        (valid)="onValid($event)"
        soho-trackdirty
        (dirty)="onDirty($event)"
        (pristine)="onPristine()"
        (afterResetDirty)="onAfterResetDirty($event)"
      />
    </ng-template>
  </div>
</div>
<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>

